/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
} from 'material-react-table';
import {
  Typography,
  TextField,
  Box,
  InputAdornment,
  useMediaQuery,
  Menu,
  MenuItem,
  Pagination,
  PaginationItem,
  Button,
  useTheme,
} from '@mui/material';
import { MRT_Cell } from 'material-react-table';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import add from 'packages/novous_web/src/assets/icons/PlusWhiteStroke.svg';
import documentIcon from 'packages/novous_web/src/assets/icons/document.svg';
import editIcon from 'packages/novous_web/src/assets/icons/edit.svg';
import downloadIcon from 'packages/novous_web/src/assets/icons/download.svg';
import deleteIcon from 'packages/novous_web/src/assets/icons/delete1.svg';
import download from 'packages/novous_web/src/assets/icons/download.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import CallingModal from 'packages/novous_web/src/common/components/CallingModal';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
import DriverAlertDashboard from '../Dashboard';
import dayjs from 'dayjs';
import DateRangeFilter from 'packages/novous_web/src/common/components/DateRange';
import calendar from 'packages/novous_web/src/assets/icons/calendar.svg';
import arrow from 'packages/novous_web/src/assets/icons/Arrow.svg';
import shareCoaching from 'packages/novous_web/src/assets/icons/ShareCoaching.svg';
import downloadWhiteIcon from 'packages/novous_web/src/assets/icons/downloadWhiteIcon.svg';
import reset from '../../../../../assets/icons/Reset.svg';
import useApiError from 'packages/novous_web/src/api/useApiError';
import AlertToast from 'packages/novous_web/src/common/components/Alert';

interface Driver {
  empId: string;
  driverName: string;
  driverScore: number;
  vehicleRegNo: string;
  phone: string;
  totalAlerts: number;
  topAlerts: string;
  driverId: string;
  employeeId: string;
}

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

interface DriverDataTableProps {
  handleTile: (data: ColumnObjType) => void;
  oldEndDate?: string;
  oldStartDate?: string;
}

const DriverAlertDataTable: React.FC<DriverDataTableProps> = ({ handleTile }) => {
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const today = dayjs();
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState('');
  const [data, setData] = useState<Driver[]>([]);
  const [filteredData, setFilteredData] = useState<Driver[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedDriver, setSelectedDriver] = useState<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const previousStartDate = location.state?.startDate || '';
  const previousEndDate = location.state?.endDate || '';
  const previousSelectedDuration = location.state?.selectedDuration || 'Today';
  const isSmallScreen = useMediaQuery('(max-width:850px)');
  const [currentPage, setCurrentPage] = useState(1);
  const paginatedArr = useRef<any[]>([null]);
  const [paginationKeys, setPaginationKeys] = useState<{ [key: number]: string | null }>({ 1: null });
  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const handleOpen = () => setIsCustomiseModalOpen(true);
  const {
    data: DriversData,
    error: DriversError,
    loading: DriversLoading,
    fetchData: fetchDriversData,
  } = useAxios<{ data: { driverLists: any[]; lastEvaluatedKey: null } }>(
    `${API_ENDPOINTS.alarm.DRIVER_ALERT_LIST}`,
    'POST',
  );

  const { user } = useAuth();
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const [columnObj, setColumnObj] = useState<ColumnObjType>({
    driverId: { name: 'Driver ID', status: true },
    employeeId: { name: 'Employee ID', status: true },
    driverName: { name: 'Driver Name', status: true },
    phoneNumber: { name: 'Contact', status: true },
    topAlerts: { name: 'Top three alert types received', status: true },
    totalAlerts: { name: '#Alerts Received', status: true },
    actions: { name: 'Actions', status: true },
  });
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [startDate, setStartDate] = useState(previousStartDate);
  const [endDate, setEndDate] = useState(previousEndDate);
  const [tilesObj, setTilesObj] = useState<ColumnObjType>({
    Stat1: { name: 'Under Coaching', status: true },
    Stat2: { name: 'Coaching Required', status: true },
    Stat3: { name: 'Coaching Completed', status: true },
    Stat4: { name: 'Avg Alerts Per Driver', status: true },
  });
  const dateRangeArr = ['Today', 'Yesterday', '7 Days', '15 Days', '30 Days', 'Custom Range'];
  const scoreData = [
    { name: 'Score: 0 - 70', value: 240 },
    { name: 'Score: 71 - 90', value: 560 },
    { name: 'Score: 91 - 100', value: 202 },
  ];

  const [selectedDuration, setSelectedDuration] = useState(previousSelectedDuration || dateRangeArr[0]);
  const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(null);
  const [calendarMenuAnchorEl, setCalendarMenuAnchorEl] = useState<null | HTMLElement>(null);
  const handleFilterClose = () => setIsFilterModelOpen(false);
  const getDateRange = (range: string) => {
    const today = dayjs();
    let startDate, endDate;

    switch (range) {
      case 'Today':
        startDate = today.format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case 'Yesterday':
        startDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        endDate = startDate;
        break;
      case '7 Days':
        startDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '15 Days':
        startDate = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '30 Days':
        startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      default:
        startDate = '';
        endDate = '';
    }
    return { startDate, endDate };
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setCalendarMenuAnchorEl(event.currentTarget);
    setCalendarAnchorEl(event.currentTarget);
  };

  const handleCalendarClose = () => {
    setShowDatePicker(false);
    // setStartDate("");
    // setEndDate("");

    // setSelectedDuration(dateRangeArr[0]);
    setCalendarAnchorEl(null);
  };

  const handleClose = (value?: string) => {
    console.info('Selected Value:', value);

    if (value) {
      // Only reset dates if changing FROM custom range TO another option
      if (selectedDuration === 'Custom Range' && value !== 'Custom Range') {
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
      }

      setSelectedDuration(value);
      setShowDatePicker(value === 'Custom Range');

      // If selecting Custom Range again, don't reset the dates - keep existing values
      if (value === 'Custom Range') {
        setCalendarAnchorEl(anchorEl); // Keep the anchor for the date picker
      }
    }

    setAnchorEl(null);
  };

  useEffect(() => {
    if (DriversData?.data?.lastEvaluatedKey) {
      // Store the lastEvaluatedKey for the next page
      const nextPage = currentPage + 1;
      const lastEvaluatedKeyStr = JSON.stringify(DriversData.data.lastEvaluatedKey);
      if (paginationKeys[nextPage] !== lastEvaluatedKeyStr) {
        setPaginationKeys(prev => ({
          ...prev,
          [nextPage]: lastEvaluatedKeyStr
        }));
      }
    }
    if (DriversData?.data) {
      const driverListData: Driver[] = DriversData?.data?.driverLists?.map((driver: any) => ({
        empId: driver?.empId ?? 'NA',
        driverName: driver?.driverName ?? 'NA',
        driverScore: driver?.driverScore ?? 0,
        topAlerts: driver?.topAlerts ?? 'NA',
        totalAlerts: driver?.totalAlerts ?? 0,
        vehicleRegNo: driver?.driverRegisterId ?? 'NA',
        phone: driver?.phoneNumber ?? 'NA',
        driverId: driver.driverId,
        employeeId: driver.employeeId,
        isDriver: driver.driver,
      }));
      setData(driverListData);
    }
  }, [DriversData, currentPage]);

  useEffect(() => {
    if (!data) {
      setFilteredData([]);
      return;
    }

    if (debouncedSearchQuery) {
      const query = debouncedSearchQuery.toLowerCase();
      const filtered = data.filter(
        (driver) =>
          (driver.driverName?.toLowerCase() || '').includes(query) ||
          (driver.empId?.toLowerCase() || '').includes(query) ||
          (driver.vehicleRegNo?.toLowerCase() || '').includes(query),
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [debouncedSearchQuery, data]);

  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, driver: Driver) => {
    setAnchorEl(event.currentTarget);
    setSelectedDriver(driver);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedDriver(null);
  };

  // const totalPages = paginatedArr?.current?.length;
  const totalPages = DriversData?.data?.lastEvaluatedKey
    ? Object.keys(paginationKeys).length
    : currentPage;

  const handleViewDriver = () => {
    navigate(`/directories/drivers/${selectedDriver.driverId}?startDate=${startDate}&endDate=${endDate}`);
    handleCloseMenu();
  };

  useEffect(() => {
    handleTile(tilesObj);
  }, [tilesObj]);
  const handleEditDriver = () => {
    alert(`Editing driver ${selectedDriver?.driverName}`);
    handleCloseMenu();
  };

  const handleDeleteDriver = () => {
    const confirmDelete = window.confirm(`Are you sure you want to delete ${selectedDriver?.driverName}?`);
    if (confirmDelete) {
      alert(`Deleted ${selectedDriver?.driverName}`);
    }
    handleCloseMenu();
  };
  useEffect(() => {
    if (!startDate && !endDate) {
      return
    }
    fetchDriversData({
      fleetId: user?.customer_id,
      fleetAdminId: user?.parentId,
      lastEvaluatedKey: null,
      startDate: startDate,
      endDate: endDate,
    });
  }, [user, startDate, endDate, selectedDuration]);
  useEffect(() => {
    const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  }, [selectedDuration]);
  const handlePageChange = async (event: React.ChangeEvent<unknown>, page: number) => {
    if (page === currentPage || DriversLoading) return;

    setCurrentPage(page)
    const keyForTargetPage = paginationKeys[page];
    await fetchDriversData({
      fleetId: user?.customer_id,
      startDate: startDate,
      endDate: endDate,
      lastEvaluatedKey: keyForTargetPage ? JSON.parse(keyForTargetPage) : null,
    });
    // if (page !== 1) {
    //   fetchDriversData({
    //     fleetId: user?.customer_id,
    //     lastEvaluatedKey: paginatedArr.current[page - 1],
    //   });
    // } else {
    //   fetchDriversData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
    // }
    // setCurrentPage(page);
  };

  const allColumns: any = useMemo(() => {
    return [
      {
        accessorKey: 'driverId',
        header: 'Driver ID',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell, row }: { cell: MRT_Cell<Driver>; row: any }) => (
          <Typography
            className="truncate"
            variant="body2"
            fontWeight={400}
            noWrap
            sx={{
              fontFamily: 'Inter Tight',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '21px',
              letterSpacing: '0%',
              textDecoration: 'underline',
              textDecorationStyle: 'solid',
              textDecorationOffset: '0%',
              textDecorationThickness: '0%',
              textDecorationSkipInk: 'auto',
              cursor: row.original.totalAlerts === 0 ? 'not-allowed' : 'pointer',
              color: row.original.totalAlerts === 0 ? '#9e9e9e' : 'inherit',
            }}
            onClick={() => {
              if (row.original.totalAlerts === 0) {
                setAlertMessage('No alerts available for this driver.');
                setAlertType('warning');
                setAlertOpen(true);
                return;
              }
              const params = new URLSearchParams();
              console.info('startDate', startDate);
              console.info('endDate', endDate);
              console.info('selectedDuration', selectedDuration);
              if (startDate && endDate) {
                params.set('startDate', startDate);
                params.set('endDate', endDate);
              }
              if (selectedDuration) {
                params.set('selectedDuration', selectedDuration);
              }
              params.set('driverId', row.original.driverId);
              params.set('driverName', row.original.driverName);
              params.set('employeeId', row.original.driverId);

              navigate(`/alarm/driver-alert-dashboard?${params.toString()}`);
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'employeeId',
        header: 'Employee ID',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }: { cell: MRT_Cell<Driver> }) => (
          <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'driverName',
        header: 'Driver Name',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }: { cell: MRT_Cell<Driver> }) => (
          <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'phoneNumber',
        header: 'Contact',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }: { cell: MRT_Cell<Driver> }) => (
          <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
            {cell.getValue<number>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'topAlerts',
        header: 'Top three alert types received',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: {
            maxWidth: '350px',
            padding: '8px',
            overflow: 'visible',
          },
        },
        Cell: ({ cell }: { cell: MRT_Cell<Driver> }) => {
          const rawValue = cell.getValue<any>();
          const alerts = Array.isArray(rawValue)
            ? rawValue.filter(Boolean)
            : typeof rawValue === 'string'
              ? rawValue.split(',').filter(Boolean)
              : [];

          if (!alerts.length) return '-';

          return (
            <Box
              sx={{
                display: 'flex',
                gap: '4px',
                flexWrap: 'nowrap',
                overflowX: 'auto',
                '&::-webkit-scrollbar': { display: 'none' },
              }}
            >
              {alerts.map((alert, index) => (
                <Box
                  key={index}
                  sx={{
                    minWidth: 69,
                    height: 24,
                    borderRadius: '8px',
                    background: '#EEEDFC',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '4px 8px',
                    fontSize: '12px',
                    lineHeight: '16px',
                    color: '#1A1A1A',
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {alert.toString().trim()}
                </Box>
              ))}
            </Box>
          );
        },
      },
      {
        accessorKey: 'totalAlerts',
        header: '#Alerts Received',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }: { cell: MRT_Cell<Driver> }) => (
          <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },

      {
        accessorKey: 'actions',
        header: 'Actions',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ row }: { row: MRT_Cell<Driver>['row'] }) => (
          <Typography
            variant="body2"
            fontWeight={700}
            color="primary"
            sx={{ cursor: 'pointer' }}
            onClick={(e) => handleOpenMenu(e, row.original)}
          >
            Actions
          </Typography>
        ),
      },
    ].filter((column) => columnObj[column.accessorKey as keyof ColumnObjType]?.status);
  }, [columnObj, isSmallScreen, startDate, endDate, selectedDuration]);

  const columns: MRT_ColumnDef<Driver>[] = useMemo(() => {
    return allColumns.filter((column: any) => {
      const key = column.accessorKey as keyof ColumnObjType;
      return columnObj[key]?.status;
    });
  }, [allColumns, columnObj]);

  const tableOptions: MRT_TableOptions<Driver> = {
    columns,
    data: filteredData?.length > 0 ? filteredData : [],
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
      },
    },
  };

  const table = useMaterialReactTable(tableOptions);
  const handleCalendarMenuClose = (value?: string) => {
    if (value) {
      setSelectedDuration(value);
      setShowDatePicker(value === 'Custom Range');

      // Only update dates if NOT switching to Custom Range
      if (value !== 'Custom Range') {
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
      }
    }

    setCalendarAnchorEl(null);
    setCalendarMenuAnchorEl(null);
  };
  const handleMenuClose = () => {
    setCalendarAnchorEl(null);
    setCalendarMenuAnchorEl(null);
  };
  const handleFilterSave = async (data: any) => {
    setCurrentPage(1); // Reset to first page
    setPaginationKeys({ 1: null });
    setData([]); // Clear existing data
    setFilteredData([]); // Clear filtered data
    await fetchDriversData({
      fleetId: user?.customer_id,
      startDate: startDate,
      endDate: endDate,
      lastEvaluatedKey: null,
      ...(data.group && { vehicleGroup: data.group }),
    });
  };
  const handleReset = () => {
    setSearchQuery('');
  };
  return (
    <>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      <div className="flex flex-col gap-4 w-full">
        <div className="flex justify-between gap-4 sm:flex-row flex-col">
          <div className="max-w-[600px]">
            <TextField
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="search" width={16} height={16} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{
                      cursor: 'pointer',
                      borderLeft: '1px solid #e0e0e0',
                      paddingLeft: '8px',
                    }}
                  >
                    <img
                      src={filterIcon}
                      onClick={() => setIsFilterModelOpen(true)}
                      alt="filter"
                      width={24}
                      height={24}
                    />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="outlined"
              color="primary"
              onClick={handleReset}
              startIcon={
                <img
                  src={reset}
                  alt="Reset"
                  style={{
                    width: 20,
                    height: 20,
                    transition: theme.transitions.create('transform'),
                    transform: 'rotate(180deg)',
                  }}
                />
              }
              sx={{
                textTransform: 'none',
                py: 1,
                px: 2,
                borderRadius: 2,
                borderWidth: 2,
                marginTop: 1,
                marginLeft: 2,
                '&:hover': {
                  borderWidth: 2,
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              Reset
            </Button>
          </div>

          <div className="flex gap-4 flex-wrap">
            {selectedDuration === 'Custom Range' && (
              <div className="flex items-center">
                <Box
                  sx={(theme) => ({
                    backgroundColor: theme.palette.selected,
                    borderRadius: '8px',
                    padding: theme.spacing(1),
                  })}
                >
                  <Typography
                    variant="subtitle2"
                    className="truncate"
                    sx={{ fontWeight: 700, marginRight: 1 }}
                  >
                    Date Range:{' '}
                    <span style={{ color: '#235AF9' }}>
                      {startDate || previousStartDate} - {endDate || previousEndDate}
                    </span>
                  </Typography>
                </Box>
              </div>
            )}
            <Button
              onClick={handleClick}
              variant="outlined"
              sx={{
                height: { xs: '28px', sm: '30px', md: '48px' },
                px: { xs: 1, sm: 2 },
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 700,
                display: 'inline-flex',
                alignItems: 'center',
                gap: { xs: 0.5, sm: 1 },
                borderColor: '#5547dd',
                backgroundColor: 'white',
                color: '#5547dd',
                minWidth: 0,
                maxWidth: '100%',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <img src={calendar} alt="Calendar" width={18} height={18} />
                <Box sx={{ display: 'block', maxWidth: '100%' }}>
                  <Typography
                    variant="body2"
                    sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {selectedDuration}
                  </Typography>
                </Box>
                <img src={arrow} alt="Arrow" width={18} height={18} />
              </Box>
            </Button>
            <Menu
              anchorEl={calendarMenuAnchorEl}
              open={Boolean(calendarMenuAnchorEl)}
              onClose={() => handleMenuClose()}
              PaperProps={{
                sx: {
                  borderRadius: '8px',
                  top: '10px',
                  boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                },
              }}
            >
              {dateRangeArr.map((label) => (
                <MenuItem
                  key={label}
                  onClick={() => handleCalendarMenuClose(label)}
                  sx={(theme) => ({
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      backgroundColor: theme.palette.action.hover,
                    },
                    backgroundColor: selectedDuration === label ? theme.palette.selected : 'transparent',
                  })}
                >
                  <Typography variant="button" textTransform={'none'}>
                    {label}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
            <Menu
              anchorEl={calendarAnchorEl}
              open={showDatePicker}
              onClose={handleCalendarClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              sx={{
                '& .MuiPaper-root': {
                  borderRadius: '8px',
                  padding: '0px',
                  boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                  marginTop: '-240px', // Small gap between button and menu
                },
              }}
              MenuListProps={{
                sx: { padding: 0 }, // Remove default padding
              }}
            >
              <DateRangeFilter
                onCancel={handleCalendarClose}
                onApply={(from, to) => {
                  setStartDate(from);
                  setEndDate(to);
                  setSelectedDuration('Custom Range');
                  setShowDatePicker(false);
                  setCalendarAnchorEl(null);
                }}
                initialFrom={startDate}
                initialTo={endDate}
              />
            </Menu>
            <CustomIconButton
              icon={<img src={Custom} alt="Custom" width={16} height={16} />}
              text="Customize"
              background="transparent"
              outline={false}
              onClick={handleOpen}
            />
          </div>
        </div>
        <MaterialReactTable table={table} />
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
          {selectedDriver?.isDriver && (
            <MenuItem onClick={handleViewDriver} sx={{ padding: '12px 16px' }}>
              <img src={documentIcon} alt="View Driver" style={{ marginRight: 8 }} />
              <Typography variant="body2" fontWeight={600}>
                View Driver
              </Typography>
            </MenuItem>
          )}
          <MenuItem onClick={handleEditDriver} sx={{ padding: '12px 16px' }}>
            <img src={shareCoaching} alt="Edit Driver" style={{ marginRight: 8 }} />
            <Typography variant="body2" fontWeight={600}>
              Share Coaching
            </Typography>
          </MenuItem>
          {/* <MenuItem onClick={handleDeleteDriver} sx={{ padding: "12px 16px" }}>
            <img
              src={deleteIcon}
              alt="Delete Driver"
              style={{ marginRight: 8 }}
            />
            <Typography variant="body2" color="error" fontWeight={600}>
              Delete Driver
            </Typography>
          </MenuItem> */}
        </Menu>
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            color="primary"
            siblingCount={0}
            boundaryCount={0}
            renderItem={(item) => {
              if (item.type === 'page' && item.page !== null && item.page > currentPage) {
                return null;
              }
              return <PaginationItem {...item} />;
            }}
          />
        </Box>
      </div>

      <CustomiseTableModal
        open={isCustomiseModalOpen}
        onClose={() => setIsCustomiseModalOpen(false)}
        onReset={() => console.info('Reset clicked!')}
        title="Customize Your Table"
        description="Select and arrange table columns as you prefer."
        columnObj={columnObj}
        setColumnObj={setColumnObj}
        tilesObj={tilesObj}
        setTilesObj={setTilesObj}
      />

      <FilterDataModel
        open={isFilterModel}
        // onClose={() => setIsFilterModelOpen(false)}
        onReset={() => console.info('Reset filter!')}
        // handleFilterSave={(filters) => console.info("Save filters:", filters)}
        title="Filter Drivers"
        description="Refine the driver list with these filters."
        onClose={handleFilterClose}
        handleFilterSave={handleFilterSave}
        showTripStatus={false}
        trgtcData={true}
      />
    </>
  );
};

export default DriverAlertDataTable;
